import { Button, useMediaQuery } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { REPs } from "../../config";
import { ChartFooter } from "../styles/common.styled";
import {
  ACGrid,
  ACGridContentWrapper,
  ACGridItem,
} from "../styles/compare.styled";
import { useEffect, useState } from "react";
import { TestCompareData } from "./test_data";
import { pushToDataLayer } from "../data";

const DMGrid = (props:any) => {
  const [compareData, setCompareData] = useState<any>([]);
  const navigate = useNavigate();
  const location = useLocation();
  const mobileSize = useMediaQuery("(max-width:430px)");
  const {
    products,
    dmPlans,
    setOneRepPlanList,
    setShowModal,
    showModal,
    promoCode,
  } = props

  // const dmPlans = TestCompareData;

  // const TestGridData = [
  //   {
  //     id: "196",
  //     value: 14.7,
  //     label: "Constellation",
  //   },
  //   {
  //     id: "163",
  //     value: 17.5,
  //     label: "Direct Energy",
  //   },
  //   {
  //     id: "176",
  //     value: 17.6,
  //     label: "Txu Energy",
  //   },
  //   {
  //     id: "159",
  //     value: 18.2,
  //     label: "Reliant",
  //   },
  // ];
  useEffect(() => {
    if (!dmPlans || dmPlans.length === 0) return;
    if (promoCode === "OFFERKA1") {
      //compare with Reliant id 159
      setCompareData(
        dmPlans.filter(
          (plan:any) => plan.provider_id === "196" || plan.provider_id === "159"
        )
      );
    } else if (promoCode === "OFFERKA4") {
      //compare with TXU id 176
      setCompareData(
        dmPlans.filter(
          (plan:any) => plan.provider_id === "196" || plan.provider_id === "176"
        )
      );
    }
  }, [dmPlans, promoCode]);


  let saving:any;
  if (compareData && compareData.length > 0) {
    const rateDiff = (parseFloat(compareData[1].price1000) *10) - (parseFloat(compareData[0].price1000) *10)
    saving = (((rateDiff) / (parseFloat(compareData[1].price1000) * 10)) * 100).toFixed(0)
  }

  const getIcon = (providerId :any) =>{
    if (providerId === '196') {
      return '/images/logo-inverted.png'
    }
    if (providerId === '176') {
      return '/images/rep_logos/176-1.svg'
    }
    if (providerId === '159') {
      return '/images/rep_logos/159-1.png'
    }
  }

  const getPlanName = (plan:any) =>{
    const providerId = plan.provider_id
    if (providerId === '196') {
      return 'Fixed Rate + Bill Credit'
    }
    if (providerId === '176') {
      return plan.plan_name
    }
    if (providerId === '159') {
      return 'Secure Advantage®'
    }
  }

  if (compareData.length  === 0) return null;

  const pushDataLayer = (product:any) =>{
    const {plan_name, plan_id, contract_term} = product;
    pushToDataLayer({
      event: "sign_up_start",
      electricity_plan_name: plan_name,
      electricity_rate_plan_id: plan_id,
      plan_term: contract_term,
      page_path: location.pathname,
      campaign_source:'DirectMail_Spring2025'
    });
  }

  console.log(location.pathname)
  return (
    <ACGrid container spacing={0} columns={compareData.length * 3 + 3}>
      <ACGridItem item xs={3}></ACGridItem>
      {compareData?.map((plan:any, index:number) => {
        if (index !== -1) {
          return (
            <ACGridItem
              item
              xs={3}
              className={plan.provider_id !== "196" ? "col-header" : ""}
            >
              <ACGridContentWrapper
                className={
                  plan.provider_id !== "196"
                    ? "col-header-wrapper"
                    : "rep-header"
                }
              >
                <img
                  src={getIcon(plan.provider_id)}
                  width="100px"
                  height="60px"
                  alt="Logo"
                />
              </ACGridContentWrapper>
            </ACGridItem>
          );
        }
        return null;
      })}
      <ACGridItem className="row-header" item xs={3}>
        <ACGridContentWrapper>
          <strong>Plan Name</strong>
        </ACGridContentWrapper>
      </ACGridItem>
      {compareData.map((plan:any, index:any) => {
        return (
          <>
            <ACGridItem className={index === 0 ? "rep-column" : ""}  item xs={3}>
              <ACGridContentWrapper>
                <p>{getPlanName(plan)}</p>
              </ACGridContentWrapper>
            </ACGridItem>
          </>
        );
      })}
      <ACGridItem className="row-header" item xs={3}>
        <ACGridContentWrapper>
          <strong>Fixed Electric Supply Rate</strong>
          <span className="sub-title">Based on 1000 kWh</span>
        </ACGridContentWrapper>
      </ACGridItem>
      {compareData.map((plan:any, index:any) => {
        return (
          <>
              <ACGridItem className={index === 0 ? "rep-column" : ""} item xs={3}>
                <ACGridContentWrapper>
                  <strong className="price">
                    {parseFloat(plan.price1000).toFixed(1)}
                    ¢
                  </strong>
                  <span className="sub-title">per kwh</span>
                </ACGridContentWrapper>
              </ACGridItem>
          </>
        );
      })}
      <ACGridItem className="row-header" item xs={3}>
        <ACGridContentWrapper>
          <strong>Plan Term</strong>
        </ACGridContentWrapper>
      </ACGridItem>
      {compareData?.map(
              (plan: any, index: number) =>
                  <ACGridItem
                    key={plan.provider_id}
                    className={index === 0 ? "rep-column" : ""}
                    item
                    xs={3}>
                    <ACGridContentWrapper>
                      <p className={"plan-term"}>{plan.contract_term} months</p>
                    </ACGridContentWrapper>
                  </ACGridItem>
            )}
      <ACGridItem className="row-header" item xs={3}>
        <ACGridContentWrapper>
          <strong>Bill Credit</strong>
          <span className="sub-title">Based on 1000 kWh</span>
        </ACGridContentWrapper>
      </ACGridItem>

      {compareData?.map(
        (plan: any, index: number) =>
            <ACGridItem
              key={index}
              className={index === 0 ? "rep-column" : ""}
              item
              xs={3}
            >
              <ACGridContentWrapper>
                {index === 0 && <p>${plan?.credit?.credit1?.credit || 0}/mo</p>}
                {index !== 0 && <p>${ 0}/mo</p>}
              </ACGridContentWrapper>
            </ACGridItem>
        )}

      <ACGridItem
              className="row-header"
              item
              xs={3}
              style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.12)" }}
            >
              <ACGridContentWrapper>
                <strong>Monthly Bill*</strong>
                <span className="sub-title">Estimated based on 1000 kWh</span>
              </ACGridContentWrapper>
            </ACGridItem>

            {compareData?.map(
              (plan: any, index: number) =>{
              const rate = parseFloat(plan.price1000).toFixed(1) || "0";
              const money = parseFloat(rate) * 10;
              return <ACGridItem
                    key={index}
                    className={index === 0 ? "rep-column" : ""}
                    item
                    xs={3}
                    style={ { borderBottom: "1px solid rgba(0, 0, 0, 0.12)" }}
                  >
                    <ACGridContentWrapper>
                      <p>${money}</p>
                      {index === 0 && <div className="green-circle">
                        <div className="circle-content">
                          <div>{saving}%</div>
                          <div>Saving</div>
                        </div>
                      </div>}
                    </ACGridContentWrapper>
                  </ACGridItem>
                })}

      <ACGridItem style={{ border: "none" }} item xs={3}></ACGridItem>
      {compareData?.map((plan:any) => {
        if (plan.provider_id === REPs[0].providerId)
          return (
            <>
              <ACGridItem className="sign-up-btn" item xs={3}>
                <div style={{ marginTop: 20 }}>
                  <Button
                    size={mobileSize ? "small" : "large"}
                    variant="secondary"
                    onClick={() => {
                      if (!showModal) {
                        const product = products.find((product:any) =>
                          product.plan_name.includes(plan.plan_name)
                        );
                        localStorage.setItem(
                          "selectProduct",
                          JSON.stringify(product)
                        );
                        pushDataLayer(product)
                        navigate(`/v2/enrollment/step1${location.search}`);
                      } else {
                        setOneRepPlanList(products);
                        setShowModal(true);
                      }
                    }}
                  >
                    Sign Up
                  </Button>
                </div>
              </ACGridItem>
            </>
          );
      })}
      <p style={{color:"#2372B9", width:"100%", textAlign:"center", marginTop:'1rem', fontWeight:'700'}}>We’ll even <span style={{textDecoration:'underline'}}>give you $150</span> to cover your cancellation fee with your current provider.</p>
    </ACGrid>
  );
};

export default DMGrid;
